import wx from "weixin-js-sdk";
import { _getWeChatAccessTokenInfo, _getOpenidByCode } from "@/api/setting.js";
import store from "@/store/index.js";

const browser = {
  versions: (() => {
    const u = navigator.userAgent;
    return {
      trident: u.indexOf("Trident") > -1, // IE内核
      presto: u.indexOf("Presto") > -1, // opera内核
      webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, // android终端
      iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, // 是否iPad
      webApp: u.indexOf("Safari") === -1, // 是否web应该程序，没有头部与底部
      weixin: u.indexOf("MicroMessenger") > -1, // 是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) === " qq", // 是否QQ
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase(),
};

const isClient = function () {
  var u = navigator.userAgent.toLocaleLowerCase(); //获取页面来源并转换成小写
  var isAndroid = browser.versions.android && window.obj4H5; //android终端
  var isiOS =
    browser.versions.ios && window.webkit && window.webkit.messageHandlers; //ios终端
  const isWx = u.match(/MicroMessenger/i) == "micromessenger";
  if (isWx) {
    return "5+WeC"; //微信
  } else if (isAndroid) {
    return "5+And"; //安卓
  } else if (isiOS) {
    return "5+Ios"; //ios
  } else {
    return "5+Web"; // Web
  }
};

const getUrlParam = function (url, key) {
  // var result = window.location.search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
  var num = url.indexOf("?"); // 获取 ？的下标
  if (num > 0) {
    url = url.slice(num + 1); // 截取 url ？后面的所有参数
    var arr = url.split("&"); // 将各个参数放到数组里
    var result = {}; // 存放结果
    for (var i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("="); // 使用 = 对 name 和 value 进行划分
      if (num > 0) {
        var name = arr[i].slice(0, num); // 获取 name 值
        var value = arr[i].slice(num + 1); // 获取 value 值
        result[name] = value;
      }
    }
    if (!result[key] || key == "" || key == null) {
      return "";
    } else {
      return result[key];
    }
  }
};

export function registerWxConfig() {
  const isWxConfigRegister = store.state.isWxConfigRegister;
  if (!isWxConfigRegister) {
    if (isClient() == "5+WeC") {
      const params = {
        url: encodeURIComponent(location.href.split("#")[0]),
      };
      _getWeChatAccessTokenInfo(params).then((res) => {
        let data = res.resultData;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appid, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.echostr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          store.commit("isWxConfigRegister", true);
        });
        // process.env.VUE_APP_APPID = data.appid;
        localStorage.setItem("appid", data.appid);
        setOpenId()
      });
    }
  }
}
export function setOpenId(num) {
  if (!sessionStorage.getItem("openid")) {
    // const appid = process.env.VUE_APP_APPID;
    const appid = localStorage.getItem("appid");
    if(!appid){
      registerWxConfig()
      return
    }
    if (isClient() == "5+WeC") {
      const code = getUrlParam(window.location.href, "code");
      if (!code) {
        if (num == 1) {
          const hashroute = "orderConfirm";
          const backUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&response_type=code&scope=snsapi_base&redirect_uri=${encodeURIComponent(
            window.location.origin + "/#/" + hashroute
          )}&state=${Math.random()}`;
          window.location.href =
            backUrl + "&v=" + new Date().getTime() + "#wechat_redirect";
        } else if (num == 2) {
          const hashroute = "course";
          const backUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&response_type=code&scope=snsapi_base&redirect_uri=${encodeURIComponent(
            window.location.origin + "/#/" + hashroute
          )}&state=${Math.random()}`;
          window.location.href =
            backUrl + "&v=" + new Date().getTime() + "#wechat_redirect";
        } else {
          const backUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&response_type=code&scope=snsapi_base&redirect_uri=${encodeURIComponent(
            window.location.href
          )}&state=${Math.random()}`;
          window.location.href =
            backUrl + "&v=" + new Date().getTime() + "#wechat_redirect";
        }
      } else {
        const code = getUrlParam(window.location.href, "code");
        const params = { code };
        _getOpenidByCode(params).then((res) => {
          sessionStorage.setItem("openid", res.resultData);
        });
      }
    }
  }
}
